import React, { useState, useEffect } from "react";
import "../styles/Community.css";
import emailjs from '@emailjs/browser';
import {
    FaTelegramPlane,
    FaFacebookF,
    FaDiscord,
    FaLinkedinIn,
    FaTwitter,
    FaWhatsapp,
    FaYoutube,
    FaInstagram,
    FaEnvelope,
    FaTimes
} from "react-icons/fa";

export default function Community() {
  const [showNewsletter, setShowNewsletter] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: ""
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Initialize EmailJS when component mounts
  useEffect(() => {
    emailjs.init('wgjjsSiO1VBAfepuX');
  }, []);

  const platforms = [
    {
      name: "Telegram",
      icon: <FaTelegramPlane size={45} />,
      url: "https://t.me/+0CJSwb58ilAyMzUx",
    },
    {
      name: "Discord",
      icon: <FaDiscord size={45} />,
      url: "https://discord.gg/fefVTwzTAr",
    },
    {
      name: "Twitter / X",
      icon: <FaTwitter size={45} />,
      url: "https://x.com/medicureon",
    },
    {
      name: "Facebook",
      icon: <FaFacebookF size={45} />,
      url: "https://www.facebook.com/61566606205296",
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedinIn size={45} />,
      url: "https://www.linkedin.com/company/medicureon",
    },
    {
      name: "WhatsApp",
      icon: <FaWhatsapp size={45} />,
      url: "https://chat.whatsapp.com/Ia6NVGwC4AJGAj7NHdJcyc",
    },
    {
      name: "YouTube",
      icon: <FaYoutube size={45} />,
      url: "https://www.youtube.com/@medicureon",
    },
    {
      name: "Instagram",
      icon: <FaInstagram size={45} />,
      comingSoon: true,
    },
    {
      name: "Newsletter",
      icon: <FaEnvelope size={45} />,
      isNewsletter: true,
    },
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // 1. Send notification to info@medicureon.com
      const notificationParams = {
        to_email: 'info@medicureon.com', // Change this to your personal email for testing
        to_name: 'MediCureOn Team',
        from_name: formData.name,
        from_email: formData.email,
        country: formData.country,
        reply_to: formData.email,
        message: `New newsletter subscription from ${formData.name} (${formData.email}) in ${formData.country}`,
        // Add these for compatibility with single brace format
        name: formData.name,
        email: formData.email
      };

      console.log('Sending notification email...');
      // First, send notification to your team
      const notificationResponse = await emailjs.send(
        'service_aa0j8ph',
        'template_xv9b7dk', // Your Contact Us template ID
        notificationParams
      );
      console.log('Notification sent:', notificationResponse);

      console.log('Sending auto-reply email...');
      // 2. Send auto-reply to the subscriber
      const autoReplyParams = {
        to_email: formData.email,  // Main recipient
        from_email: formData.email, // This is what your template uses for "To:"
        to_name: formData.name,
        from_name: formData.name,   // This is what your template uses in the greeting
        user_name: formData.name,
        user_email: formData.email,
        country: formData.country,
        // Add all possible variations
        name: formData.name,
        email: formData.email
      };

      const autoReplyResponse = await emailjs.send(
        'service_aa0j8ph',
        'template_7mzgczm', // Your auto-reply template
        autoReplyParams
      );
      console.log('Auto-reply sent:', autoReplyResponse);
      
      setMessage("✅ Thank you for subscribing! Check your email for confirmation.");
      setFormData({ name: "", email: "", country: "" });
      
      // Close modal after 3 seconds
      setTimeout(() => {
        setShowNewsletter(false);
        setMessage("");
      }, 3000);

    } catch (error) {
      console.error("Subscription error:", error);
      console.error("Error details:", error.text, error.status);
      setMessage("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePlatformClick = (e, platform) => {
    if (platform.isNewsletter) {
      e.preventDefault();
      setShowNewsletter(true);
    } else if (platform.comingSoon) {
      e.preventDefault();
      alert("Coming soon! 🚀");
    }
  };

  return (
    <div className="community-container">
      <h1 className="community-title">🌐 Join the MediCoin Community</h1>
      <p className="community-subtitle">
        Be part of the future of decentralized healthcare. Connect with us and stay up to date!
      </p>

      <div className="community-grid">
        {platforms.map((platform) => (
          <a
            key={platform.name}
            href={platform.url || "#"}
            target={platform.url ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="community-link pulse-glow"
            onClick={(e) => handlePlatformClick(e, platform)}
          >
            {platform.icon}
            {platform.name}
          </a>
        ))}
      </div>

      {/* Newsletter Modal */}
      {showNewsletter && (
        <div className="newsletter-modal-overlay" onClick={() => setShowNewsletter(false)}>
          <div className="newsletter-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowNewsletter(false)}>
              <FaTimes />
            </button>
            
            <h2>📮 Subscribe to Our Newsletter</h2>
            <p>Stay updated with the latest MediCoin news and updates!</p>
            
            <form onSubmit={handleSubmit} className="newsletter-form">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="newsletter-input"
              />
              
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="newsletter-input"
              />
              
              <input
                type="text"
                name="country"
                placeholder="Your Country"
                value={formData.country}
                onChange={handleInputChange}
                required
                className="newsletter-input"
              />
              
              <button 
                type="submit" 
                className="newsletter-submit"
                disabled={loading}
              >
                {loading ? "Subscribing..." : "Subscribe Now"}
              </button>
              
              {message && (
                <p className={`newsletter-message ${message.includes('✅') ? 'success' : 'error'}`}>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        .newsletter-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .newsletter-modal {
          background: linear-gradient(135deg, #1a1a2e 0%, #2d2d44 100%);
          border-radius: 20px;
          padding: 40px;
          max-width: 450px;
          width: 100%;
          position: relative;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .close-btn {
          position: absolute;
          top: 20px;
          right: 20px;
          background: none;
          border: none;
          color: #fff;
          font-size: 24px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .close-btn:hover {
          transform: rotate(90deg);
          color: #ff6b6b;
        }

        .newsletter-modal h2 {
          color: #fff;
          margin-bottom: 10px;
          text-align: center;
          font-size: 28px;
        }

        .newsletter-modal p {
          color: #aaa;
          text-align: center;
          margin-bottom: 30px;
        }

        .newsletter-form {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .newsletter-input {
          padding: 15px 20px;
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 16px;
          transition: all 0.3s ease;
        }

        .newsletter-input:focus {
          outline: none;
          border-color: #a78bfa;
          background: rgba(255, 255, 255, 0.1);
        }

        .newsletter-input::placeholder {
          color: #888;
        }

        .newsletter-submit {
          padding: 15px 30px;
          border-radius: 10px;
          border: none;
          background: linear-gradient(45deg, #6366f1, #a78bfa);
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 10px;
        }

        .newsletter-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(99, 102, 241, 0.4);
        }

        .newsletter-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .newsletter-message {
          text-align: center;
          margin-top: 15px;
          padding: 10px;
          border-radius: 8px;
          font-size: 14px;
        }

        .newsletter-message.success {
          color: #10b981;
          background: rgba(16, 185, 129, 0.1);
        }

        .newsletter-message.error {
          color: #ef4444;
          background: rgba(239, 68, 68, 0.1);
        }

        @media (max-width: 768px) {
          .newsletter-modal {
            padding: 30px 20px;
          }

          .newsletter-modal h2 {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
}